import type { ICellRendererParams } from 'ag-grid-community';
import type { ForecastRun, ForecastRunStatus } from '../../schema';

const STYLES: Record<
  ForecastRunStatus,
  { label: string; bg: string; text: string; dot: string }
> = {
  running: {
    label: 'Running',
    bg: 'bg-secondary/15',
    text: 'text-secondary',
    dot: 'bg-secondary',
  },
  succeeded: {
    label: 'Succeeded',
    bg: 'bg-success/15',
    text: 'text-success',
    dot: 'bg-success',
  },
  failed: {
    label: 'Failed',
    bg: 'bg-danger/15',
    text: 'text-danger',
    dot: 'bg-danger',
  },
  partial: {
    label: 'Partial',
    bg: 'bg-warning/15',
    text: 'text-warning',
    dot: 'bg-warning',
  },
};

export function RunStatusBadge(
  p: ICellRendererParams<ForecastRun, ForecastRunStatus>,
) {
  const status = p.value;
  if (!status) return null;
  const s = STYLES[status];
  return (
    <span
      className={[
        'inline-flex w-fit shrink-0 items-center gap-1.5 self-center rounded-full px-2 py-[3px]',
        'text-[10px] font-black uppercase leading-none tracking-tight',
        s.bg,
        s.text,
      ].join(' ')}
    >
      <span aria-hidden className={`h-1.5 w-1.5 shrink-0 rounded-full ${s.dot}`} />
      <span>{s.label}</span>
    </span>
  );
}
